/**
 * @flow
 * @relayHash 833b4b649fad9e60b0bdce1af877ba32
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PortfolioItemsAction = "ADD" | "EDIT" | "REMOVE" | "REORDER" | "%future added value";
export type PortfolioType = "CART" | "HEART" | "%future added value";
export type ModifyPortfolioItemsInput = {|
  action: PortfolioItemsAction,
  endPortfolioItemId?: ?string,
  itemsIds?: ?$ReadOnlyArray<?string>,
  note?: ?string,
  portfolioItemsIds?: ?$ReadOnlyArray<?string>,
  portfolioId?: ?string,
  portfolioType?: ?PortfolioType,
  startPortfolioItemId?: ?string,
  targetPortfolioItemId?: ?string,
  userId: string,
  clientMutationId?: ?string,
|};
export type SharedModifyPortfolioItemsMutationVariables = {|
  input: ModifyPortfolioItemsInput
|};
export type SharedModifyPortfolioItemsMutationResponse = {|
  +modifyPortfolioItems: ?{|
    +removedItemIds: ?$ReadOnlyArray<?string>
  |}
|};
export type SharedModifyPortfolioItemsMutation = {|
  variables: SharedModifyPortfolioItemsMutationVariables,
  response: SharedModifyPortfolioItemsMutationResponse,
|};
*/


const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "ModifyPortfolioItemsInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "modifyPortfolioItems",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "ModifyPortfolioItemsInput!"
      }
    ],
    "concreteType": "ModifyPortfolioItemsPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "removedItemIds",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SharedModifyPortfolioItemsMutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "SharedModifyPortfolioItemsMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "SharedModifyPortfolioItemsMutation",
    "id": "app-buyer-finding/209.0.0-2019-03-27T14:13:29.601Z/SharedModifyPortfolioItemsMutation",
    "text": null,
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '09ebacc9d6688ff341b6058eb9f8bba8';
module.exports = node;
